

















import { Vue, Component } from 'vue-property-decorator'
import BlockAbout from './components/BlockAbout.vue'
import BlockAdv from './components/BlockAdv.vue'
import BlockCapabilities from './components/BlockCapabilities.vue'
import BlockInstructions from './components/BlockInstructions.vue'
import BlockBottom from './components/BlockBottom.vue'
import FooterApp from './components/FooterApp.vue'
import NavbarApp from './components/NavbarApp.vue'
import BlockHero from './components/BlockHero.vue'
import MenuMobile from './components/MenuMobile.vue'
import sleep from './mixins/sleep'
import scrollTo from './mixins/scrollTo'

const grid = require('@/styles/grid-config.json')

@Component({
  components: {
    BlockAbout,
    BlockAdv,
    BlockCapabilities,
    BlockInstructions,
    BlockBottom,
    FooterApp,
    NavbarApp,
    BlockHero,
    MenuMobile
  },
})

export default class App extends Vue {
  scrollKeys = {37: 1, 38: 1, 39: 1, 40: 1}
  globalLoaderIsShown: boolean = false
  menuIsShown: boolean = false
  navbarHeight: number = 73
  hashString: string = null

  created() {
    window.addEventListener('resize', () => this.windowResizeHandler(grid))
    this.windowResizeHandler(grid)
  }
  async mounted() {
    await this.$nextTick()
    this.manageHash()
  }

  toggleMenuMobile() {
    this.menuIsShown = !this.menuIsShown
    if (this.menuIsShown) document.body.classList.add('modal-open')
    else document.body.classList.remove('modal-open')
  }
  closeMenuMobile() {
    this.menuIsShown = false
    document.body.classList.remove('modal-open')
  }
  windowResizeHandler(grid) {
    if (!grid) return

    const queriesAll = Object.entries(grid.queries)
    const queriesCurrent = queriesAll.filter((query: any) => window.matchMedia(query[1]).matches)
    const breakpoint = queriesCurrent && queriesCurrent.find((rule: any) => rule[0].length === 2)[0]

    this.$store.commit('setBreakpoint', breakpoint)
  }
  async manageHash() {
    const hash = this.$route.hash
    this.hashString = hash
    if (hash) this.$router.push({path: `/${hash}`}).catch(() => this.$router.push({path: '/'}, () => this.$router.push({path: `/${this.hashString}`})))
  }
  setMenuMobileStyle() {
    return `top: ${this.navbarHeight}px;`
  }
  // disable scroll methods
  preventDefault(e) {
    e.preventDefault();
  }
  preventDefaultForScrollKeys(e) {
    if (this.scrollKeys[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  }
  disableScroll() {
    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = null
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: () => { supportsPassive = true; } 
      }));
    } catch(e) {}

    const wheelOpt = supportsPassive ? { passive: false } : false;
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
    window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }
  enableScroll() {
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    window.removeEventListener(wheelEvent, this.preventDefault); 
    window.removeEventListener('touchmove', this.preventDefault);
    window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }
}
